<script lang="ts">
	import Insurance from '$lib/components/Insurance/Insurance.svelte';
	import Ideal from '$lib/components/Insurance/Ideal.svelte';
	import { FAQ } from '$lib/components/Global/FAQ';
	import Instructions from '$lib/components/Insurance/Instructions.svelte';
	import Partners from '$lib/components/Insurance/Partners.svelte';
	import Save from '$lib/components/Insurance/Save.svelte';
	import Contact from '$lib/components/Insurance/Contact.svelte';
	import Help from '$lib/components/Global/Help.svelte';
	import __ from '$lib/stores/TranslationStore';
	import NewsletterForm from '$lib/components/Global/Newsletter/NewsletterForm.svelte';
	import ProductHero from '$lib/components/Global/ProductHero.svelte';
	import insurance from '$lib/assets/images/insurance.webp';
</script>

<svelte:head>
	<title>{$__('O seguro de vida certo para crédito habitação')}</title>
	<meta
		name="description"
		content={$__(
			'Qual o seguro mais vantajoso para o seu crédito habitação? Os nossos agentes negoceiam os melhores preços e coberturas para o seu perfil.'
		)}
	/>
	<meta name="keywords" content={$__('Seguro de vida crédito habitação')} />
	<meta property="og:image" content="/og/open-graph-seguros.png" />
</svelte:head>

<!-- <Insurance /> -->
<ProductHero
	color="secondary-bright"
	category={$__('Seguros')}
	title={$__('O melhor seguro sem contratempos, para si e para a sua família')}
	caption={$__(
		'Sempre protegido sem preocupações, com coberturas que se adaptam ao seu dia a dia.'
	)}
	cta={{
		text: $__('Encontrar seguro'),
		href: '/simulador/seguro-vida-habitacao'
	}}
	img={{
		src: insurance,
		alt: $__('Seguros')
	}}
/>
<Ideal />
<Instructions />
<Partners />
<Save />
<NewsletterForm />
<Contact />
<FAQ category="Seguros" />
<Help />
